import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import Select from "react-select"
import {
  getCompletedSurveys,
  getPlaceSurveyReplies,
  resetSurveysData,
} from "store/actions"
import Table from "components/Table"
import surveyRepliesListColumns from "./surveyRepliesListColumns"
import { get } from "helpers/api_helper"
import XLSX from "xlsx"

const Surveys = ({
  history,
  getCompletedSurveys,
  completedSurveys,
  match,
  resetSurveysData,
  placeSurveyReplies,
  getPlaceSurveyReplies,
  loading,
}) => {
  const moment = require("moment-timezone")
  const timeZone = moment.tz.guess()
  const [selectedSurvey, setSelectedSurvey] = useState()

  useEffect(() => {
    getCompletedSurveys({ id: match?.params?.id })
    getPlaceSurveyReplies({
      o: "created_at",
      od: "desc",
      page: 1,
      per_page: 25,
      place_id: match?.params?.id,
      timeZone: timeZone,
    })
    return () => {
      resetSurveysData()
    }
  }, [])

  const downloadHandler = async () => {
    const surveyResponse = await get("/admin/place-survey-replies", {
      params: {
        o: "created_at",
        od: "desc",
        page: 1,
        per_page: placeSurveyReplies?.total,
        place_id: match?.params?.id,
        timeZone: timeZone,
        ...(selectedSurvey?.value ? { survey_id: selectedSurvey?.value } : {}),
      },
    })

    const placeResponse = await get("/place/" + match?.params?.id)

    const worksheet = XLSX.utils.json_to_sheet(
      surveyResponse?.data.map(item => {
        return {
          Survey: item?.question?.survey?.name,
          Name: item?.name,
          Email: item?.email,
          Question: item?.question?.question,
          Answer: item?.answer_id ? item?.answer?.answer : item?.answer_text,
          Date_Created: item?.created_at?.date,
          Place_Name: placeResponse?.name,
          Place_Address_Street_1: placeResponse?.address_street_1,
          Place_City: placeResponse?.city,
          Place_State: placeResponse?.state,
          Place_Zip_Code: placeResponse?.zip_code,
          Place_Country_Code: placeResponse?.country_code,
        }
      })
    )
    const csv = XLSX.utils.sheet_to_csv(worksheet, {
      strip: true,
      blankrows: true,
      skipHidden: true,
    })
    saveAs(
      new Blob([csv], { type: "text/plain;charset=utf-8" }),
      `${placeResponse.name} Survey Replies Report.csv`
    )
  }

  const handlePageChange = page => {
    getPlaceSurveyReplies({
      o: "created_at",
      od: "desc",
      page: page,
      per_page: 25,
      place_id: match?.params?.id,
      timeZone: timeZone,
      ...(v?.value ? { survey_id: v?.value } : {}),
    })
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Surveys" />
        <Container fluid>
          <Card>
            <CardBody>
              <Row className="d-flex justify-content-end">
                <Col xs="auto">
                  <SaveButton
                    type="button"
                    content="Back"
                    color="light"
                    onClick={() => history.goBack()}
                  />
                </Col>
              </Row>
              {completedSurveys?.length > 0 && (
                <Row>
                  <Col xs="auto" className="mt-2 my-1">
                    Select Survey:
                  </Col>
                  <Col xs="auto" className="my-1">
                    <div style={{ width: "250px" }}>
                      <Select
                        value={selectedSurvey}
                        onChange={v => {
                          setSelectedSurvey(v)
                          getPlaceSurveyReplies({
                            o: "created_at",
                            od: "desc",
                            page: 1,
                            per_page: 25,
                            place_id: match?.params?.id,
                            timeZone: timeZone,
                            ...(v?.value ? { survey_id: v?.value } : {}),
                          })
                        }}
                        options={[
                          { value: null, label: "All Surveys" },
                          ...completedSurveys?.map(survey => ({
                            value: survey?.id,
                            label: survey?.name,
                          })),
                        ]}
                      />
                    </div>
                  </Col>
                  <Col xs="auto" className="my-1">
                    <SaveButton
                      type="button"
                      content="Download Report"
                      onClick={downloadHandler}
                    />
                  </Col>
                </Row>
              )}
              <Row className="my-2 mt-4">
                <Col>
                  <h5>Number of Completions: {completedSurveys?.length}</h5>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <Table
                    columns={surveyRepliesListColumns()}
                    data={placeSurveyReplies?.data}
                    paginationData={{
                      current_page: placeSurveyReplies?.current_page,
                      last_page: placeSurveyReplies?.last_page,
                      total_items: placeSurveyReplies?.total,
                      items_per_page: placeSurveyReplies?.per_page,
                      from: placeSurveyReplies?.from,
                      to: placeSurveyReplies?.to,
                      first_page: 1,
                    }}
                    onPageChange={handlePageChange}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  completedSurveys: state.PlacesList.completedSurveys,
  placeSurveyReplies: state.PlacesList.placeSurveyReplies,
  loading: state.PlacesList.loading,
})

const mapDispatchToProps = dispatch => ({
  getCompletedSurveys: values => dispatch(getCompletedSurveys(values)),
  resetSurveysData: () => dispatch(resetSurveysData()),
  getPlaceSurveyReplies: values => dispatch(getPlaceSurveyReplies(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Surveys))
